/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useContext, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { deleteBackgroundImage, setSetting } from '../../Components/action/common';
import { setBackgroundImages, setColorPicker, setColorPickerPopup, setThemeDefaultImage, setDarkThemeDefaultImage, setColorPickerDark } from '../../redux/slices/ThemeSlice'
import { useDispatch, useSelector } from 'react-redux'
import { jsx } from "@emotion/core";
import { fetchBackgroundImages } from '../../Components/action/utilities';
import { ColorPaletteIcon, Trash } from '../../Components/LandingHeader/Feedback/icons/Icons';
import { pushToSetting, setSettings } from '../../redux/slices/SettingSclice';
import BackgroundImageCard from '../../Components/common/BackgroundImageCard';
import DefaultBackgroundImages from './DefaultBackgroundImages';
import CustomBackgroundImages from './CustomBackgroundImages';
import { AuthContext } from '../../AuthProvider';

function ColorPickerSetting({ show = true, onHide }) {
  const dispatch = useDispatch()
  const { themeMode } = useContext(AuthContext)

  // global state
  const settings = useSelector(state => state.settings.settings)
  const { colorPicker, colorPickerDark, backgroundImageId, darkBackgroundImageId, backgroundImages } = useSelector(state => state.theme)
  const [image, setImage] = useState(null);
  const [activeTab, setActiveTab] = useState('default');

  useEffect(() => {
    fetchBackgroundImages().then(async (images) => {
      dispatch(setBackgroundImages(images));
      dispatch(setColorPickerPopup(false));
    });
  }, [])

  useEffect(() => {
    if (!image) return;
    if(themeMode == 'dark'){
      dispatch(setDarkThemeDefaultImage(image.id));
    }else{
      dispatch(setThemeDefaultImage(image.id))
    }
  }, [image, themeMode])

  const fetchSettingData = async (applied = false) => {
    if(applied){
      onHide();
      return;
    }

    try {
      let defaultImage = null;
      let defaultDarkImage = null;
      setImage(null);
      dispatch(setSettings(settings));
      // Set color picker
      dispatch(setColorPicker(settings?.accentColor ?? colorPicker))
      dispatch(setColorPickerDark(settings?.accentColorDark ?? colorPickerDark))
      // Local background image
      if(settings?.backgroundImageId){
        defaultImage = backgroundImages.find(img => img.id == settings?.backgroundImageId)?.id ?? null;
      }
      if(settings?.darkBackgroundImageId){
        defaultDarkImage = backgroundImages.find(img => img.id == settings?.darkBackgroundImageId)?.id ?? null;
      }
      // If local not found then apply global default background image
      if(!defaultImage){
        defaultImage = (backgroundImages.find(img => img.isDefault && !img.darkMode))?.id ?? null;
      }
      if(!defaultDarkImage){
        defaultDarkImage = (backgroundImages.find(img => img.isDefault && img.darkMode))?.id ?? null;
      }

      defaultImage && dispatch(setThemeDefaultImage(defaultImage));
      defaultDarkImage && dispatch(setDarkThemeDefaultImage(defaultDarkImage));
    } catch ({ response }) {}
  }

  const onApplyColorPicker = async (e, color) => {
    e?.stopPropagation();
    e?.preventDefault();
    try {
        let newSettings = { ...settings};
        if(themeMode == 'dark'){
          newSettings = { ...newSettings, darkBackgroundImageId: image.id, accentColorDark: color };
          dispatch(setDarkThemeDefaultImage(image.id))
        }else{
          newSettings = { ...newSettings, backgroundImageId: image.id, accentColor: color };
          dispatch(setThemeDefaultImage(image.id))
        }
        
        dispatch(pushToSetting(newSettings));
        setSetting({ settings: newSettings });
        onHide();
    } catch (error) {}
  }

  const toggleActiveTab = (tab, e) => {
    e.preventDefault();
    e.stopPropagation();
    setActiveTab(tab);
  }

  return (
    <>
      <Modal show={image === null} onHide={onHide} className="colorPicker-model">
        <Modal.Body className='modal-body-extra-padding'>
          <div className="full-model md-model-updates w-full">
              <div className="full-model-body">
                  <div className="body-data bg-white dark:bg-black rounded-25">
                    <div className='ctTitle relative'>
                        <ColorPaletteIcon color={themeMode == "dark" ? colorPickerDark : colorPicker} fill={themeMode == "dark" ? colorPickerDark : colorPicker} />
                        <span className='darkPrimaryColor'>{themeMode == "light" ? "Light Mode" : "Dark Mode"}</span>
                    </div>
                    <div className='flex py-[30px] px-10 gap-[30px] justify-center items-center flex-col w-full'>
                      <div className='tabs flex gap-[10px] items-center justify-start w-full' css={{
                        '.tab-item': {
                          '&.active': {
                            backgroundColor: themeMode == "dark" ? colorPickerDark : colorPicker,
                            color: '#fff'
                          }
                        }
                      }}> 
                        <a href='#' className={`button button-primary tab-item ${activeTab === 'default' ? 'active' : ''}`} onClick={(e) => toggleActiveTab('default', e)}>Default</a>
                        <a href='#' className={`button button-primary tab-item ${activeTab === 'custom' ? 'active' : ''}`} onClick={(e) => toggleActiveTab('custom', e)}>Custom</a>
                      </div>
                      <div className="bg-images-thumbnails" css={{
                        display: activeTab === 'default' ? 'flex' : 'none'
                      }}>
                        <DefaultBackgroundImages backgroundImages={backgroundImages} colorPicker={themeMode == "dark" ? colorPickerDark : colorPicker} onApplyColorPicker={onApplyColorPicker} backgroundImageId={themeMode == "dark" ? darkBackgroundImageId : backgroundImageId} setImage={setImage} themeMode={themeMode} />
                      </div>
                      <div className="bg-images-thumbnails" css={{
                        display: activeTab === 'custom' ? 'flex' : 'none'
                      }}>
                        <CustomBackgroundImages backgroundImages={backgroundImages} colorPicker={themeMode == "dark" ? colorPickerDark : colorPicker} onApplyColorPicker={onApplyColorPicker} backgroundImageId={themeMode == "dark" ? darkBackgroundImageId : backgroundImageId} setImage={setImage} themeMode={themeMode} />
                      </div>
                    </div>
                  </div>
              </div>
          </div>
        </Modal.Body>
      </Modal>
      {
       image !== null && <BackgroundImageCard imageObject={image} location={image.location} color={themeMode == "dark" ? colorPickerDark : colorPicker} onCancel={fetchSettingData} onApply={onApplyColorPicker} showEyeDropper={true} themeMode={themeMode} />
      }
    </>
  )
}

export default ColorPickerSetting